import { Link } from "react-router-dom";
import Seo from "../Components/Seo.jsx";
import PageHeader from "../Components/PageHeader.jsx";
import { NOT_FOUND_PAGE } from "../seo/pages.js";

const links = [
  { to: "/tamil-classes-blacktown/", label: "Tamil classes in Blacktown" },
  { to: "/programs/", label: "Programs and learning levels" },
  { to: "/enrolment/", label: "How to enrol" },
  { to: "/events/", label: "Events" },
  { to: "/contact/", label: "Contact us and venue" },
];

const NotFound = () => (
  <>
    <Seo {...NOT_FOUND_PAGE} />
    <PageHeader
      title="Page Not Found"
      breadcrumbs={[
        { label: "Home", href: "/", icon: "bi-house" },
        { label: "Page not found", active: true },
      ]}
    />
    <section className="py-5">
      <div className="container py-lg-4">
        <p className="fs-5">
          Sorry, we couldn't find that page. It may have moved or no longer exist.
        </p>
        <p className="text-muted">These pages might help:</p>
        <ul>
          {links.map((link) => (
            <li key={link.to} className="mb-2">
              <Link to={link.to} className="red-text fw-semibold">
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  </>
);

export default NotFound;
